import { Card } from '@/components/ui/card';
import { BarChart } from '@/features/dashboard-charts';
import type { TopItemsData } from '@/entities/dashboard';

interface TopListsGridProps {
  topWarehouses: TopItemsData;
  topUsers: TopItemsData;
  isLoading: boolean;
}

export function TopListsGrid({ topWarehouses, topUsers, isLoading }: TopListsGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Top Warehouses</h3>
        <BarChart data={topWarehouses} height={300} loading={isLoading} />
      </Card>

      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Top Users</h3>
        <BarChart data={topUsers} height={300} loading={isLoading} />
      </Card>
    </div>
  );
}
